import type { ReactNode } from 'react'
import { DeckIcon } from '~/design-system/elements/DeckIcon/DeckIcon'
import styles from './ToolbarPopoverPanel.module.css'

export const ToolbarPopoverHeader = ({
  title,
  onClose,
}: {
  title: string
  onClose: () => void
}) => (
  <div className={styles.header}>
    <span className={styles.headerTitle}>{title}</span>
    <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Close">
      <DeckIcon name="close" size="button-default" />
    </button>
  </div>
)

export const ToolbarPopoverPanel = ({
  title,
  onClose,
  children,
  className = '',
}: {
  title: string
  onClose: () => void
  children: ReactNode
  className?: string
}) => (
  <div className={`${styles.panel} ${className}`}>
    <ToolbarPopoverHeader title={title} onClose={onClose} />
    {children}
  </div>
)

ToolbarPopoverPanel.displayName = 'ToolbarPopoverPanel'
